const URGENCY_BLOCK_SELECTOR = 'p, li, h1, h2, h3, h4, h5, h6';
const SECURITY_DESIGNATION_PATTERN = /\(security\)/i;
const URGENCY_PATTERN = /\burgency\b/i;

function findUrgencyBlock(root: ParentNode): Element | undefined {
  return Array.from(root.querySelectorAll(URGENCY_BLOCK_SELECTOR)).find((element) =>
    URGENCY_PATTERN.test(element.textContent || ''),
  );
}

/**
 * Security escalation macros intentionally put `(Security)` in their urgency
 * header. A refinement may rewrite the prose, but it must not remove that
 * operational designation from the draft.
 */
export function preserveSecurityUrgencyHeader(
  currentDraftHtml: string,
  refinedDraftHtml: string,
): string {
  if (!currentDraftHtml || !refinedDraftHtml) return refinedDraftHtml;

  const parser = new DOMParser();
  const currentDocument = parser.parseFromString(currentDraftHtml, 'text/html');
  const currentUrgencyBlock = findUrgencyBlock(currentDocument.body);

  if (
    !currentUrgencyBlock ||
    !SECURITY_DESIGNATION_PATTERN.test(currentUrgencyBlock.textContent || '')
  ) {
    return refinedDraftHtml;
  }

  const refinedDocument = parser.parseFromString(refinedDraftHtml, 'text/html');
  const refinedUrgencyBlock = findUrgencyBlock(refinedDocument.body);

  if (!refinedUrgencyBlock) {
    refinedDocument.body.prepend(currentUrgencyBlock.cloneNode(true));
  } else if (!SECURITY_DESIGNATION_PATTERN.test(refinedUrgencyBlock.textContent || '')) {
    refinedUrgencyBlock.replaceWith(currentUrgencyBlock.cloneNode(true));
  }

  return refinedDocument.body.innerHTML;
}
